import { configureStore } from "@reduxjs/toolkit";
import settingSlice from "./slice/settings/main";
import tradeSlice from "./slice/trade";

export const store = configureStore({
  reducer: { trade: tradeSlice.reducer, companySettings: settingSlice.reducer },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  devTools: true,
});

/**
 * @typedef { ReturnType<typeof store.getState> } RootState
 */
